
import React, { memo, useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { selectNumberingDatalist } from '../Selectors/TrackSelector/TrackSelector';
import { fetchNumberingList, InsertNumberingInwardEntry } from '../../Store/PHPSlice/Numbering/numberingApi';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';


const NumberingIssueReturn = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        id: Id,
        dt: getCurrentDate(),
        empNm: '',
        empId: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [usedTotMtr, setUsedTotMtr] = useState(0);
    const [balTotMtr, setBalTotMtr] = useState(0);
    const [baleNo, setBaleNo] = useState('');
    const [inwardData, setInwardData] = useState([]);
    const clIssInfo = useSelector(selectNumberingDatalist);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchNumberingList(Id));
    }, [Id, dispatch]);


    // console.log(formData);
    useEffect(() => {
        if (clIssInfo?.data && clIssInfo.data.length > 0) {
            const item = clIssInfo.data[0];
            // console.log(item)
            const inwMemo = clIssInfo.countId > 0 ? `R-${item.numMemo}-${parseFloat(clIssInfo.countId) + 1}` : `R-${item.numMemo}-1`;

            setFormData(prev => ({
                ...prev,
                memo: inwMemo,
                numMemo: item?.numMemo,
                ctInwId: item?.ctInwId,
                sono: item?.sono,
                ctMemo: item?.ctMemo,
                empType: item?.empType,
                empNm: item?.empNm,
                empId: item?.empId,
                itemId: item?.itemId,
                itemNm: item?.itemNm,
                clothNm: item?.clothNm,
                m1Cloth: item?.m1Cloth,
                m2Cloth: item?.m2Cloth,
                m3Cloth: item?.m3Cloth,
                cutTotQty: item?.cutTotQty,
                numIssQty: item?.numIssQty,
                reQty: item?.reQty,
                sts: item?.sts
            }));
        }
        if (clIssInfo.numberingInfo.length > 0) {
            setInwardData(clIssInfo.numberingInfo);
        }
    }, [clIssInfo]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleQtyChange = (index, e) => {
        const value = parseInt(e.target.value || 0, 10);
        const updated = inwardData.map((item, i) =>
            i === index ? { ...item, inwardQty: value <= item.bQty ? value : item.inwardQty } : item
        );

        if (value <= inwardData[index].bQty) {
            setInwardData(updated);
        } else {
            alert("Inward Qty cannot be greater than Remaining Qty.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const totalInwardQty = inwardData?.reduce((sum, item) => {
            return sum + parseFloat(item.inwardQty || 0);
        }, 0);

        const payload = {
            id: formData?.id,
            dt: formData.dt,
            numInwMemo: formData.memo,
            numMemo: formData.numMemo,
            numIssQty: formData.numIssQty,
            totInwQty: totalInwardQty,
            empId: formData.empId,
            userId: formData.userId,
            inwardInfo: inwardData.map(item => ({
                size: item.size,
                issQty: item.gQty,
                balQty: item.bQty,
                inwardQty: item.inwardQty || 0
            }))

        };
        // console.log("Submitting:", payload);
        dispatch(InsertNumberingInwardEntry(payload))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Numbering inward entry added successfully");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    }

    const fields = [
        { name: 'dt', type: 'date' }
    ];

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    }


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Numbering Issue Return</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }}>
                                        {/* <input
                                            type="date"
                                            value={new Date().toISOString().split('T')[0]}
                                            max={new Date().toISOString().split('T')[0]}
                                            style={{ width: '100%' }}
                                        /> */}
                                        {fields.map((field) => (
                                            <DateInputComponent
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                            />
                                        ))}
                                    </td>
                                    <td style={{ width: '200px' }}>Inward Memo No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.memo}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Numbering Memo No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.numMemo}</td>
                                    <td style={{ width: '200px' }}>Cutting Return No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.ctMemo}</td>
                                </tr>

                                {formData.ctInwId !== '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>SO No.</td>

                                        <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.sono}</td>
                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.clothNm}</td>
                                </tr>

                                <tr>
                                    <td>M1 Cloth</td>

                                    <td>{formData.m1Cloth || '-'}</td>
                                    <td>M2 Cloth</td>

                                    <td>{formData.m2Cloth || '-'}</td>
                                </tr>
                                <tr>
                                    <td>M3 Cloth</td>

                                    <td>{formData.m3Cloth || '-'}</td>
                                </tr>
                            </tbody>


                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Cutting Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Issue Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Remaining Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Inward Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(inwardData) && inwardData.length > 0 ? (
                                        inwardData.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.ctQty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.gQty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.bQty}</TableCell>
                                                <TableCell
                                                    key={index}
                                                    sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                    align='center'
                                                >
                                                    <input
                                                        type="text"
                                                        value={item.inwardQty || 0}
                                                        onChange={(e) => handleQtyChange(index, e)}
                                                        style={{ width: '80px', padding: '1px' }}
                                                    />
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                        </TableContainer>
                        <Grid item xs={12} textAlign="center">
                            <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                        </Grid>
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default NumberingIssueReturn;
